export { default } from "./Footer";



// WEBPACK FOOTER //
// ./src/components/sale/posSection/footer/index.js